<template>
  <main
    class="
      bg-white
      min-h-screen
      col-start-1
      pl-4
      md:pl-8
      lg:pl-0
      lg:col-start-3
      col-end-13
      relative
      z-10
    "
    v-if="programs"
    v-infinite-scroll="loadMore"
    infinite-scroll-disabled="busy"
    infinite-scroll-distance="10"
  >
    <grid-letters text="program" />
    <div class="relative z-10 pb-8">
      <div
        v-for="(program, index) in upcoming"
        :key="program.uid"
        class="w-full md:min-h-1/3 block md:grid md:grid-cols-10 pt-4 md:pt-8"
      >
        <!-- left side -->
        <div class="col-span-3 md:min-h-1/3 pr-4 pb-4 md:pb-0">
          <div class="w-full flex flex-col uppercase">
            <div
              v-if="index === 0"
              class="flex-1 w-full pb-4 uppercase"
              @mousemove="changeCursor('')"
            >
              UPCOMING
            </div>
            <div
              class="flex-1 mb-4"
              @mousemove="changeCursor('')"
              v-html="program.title"
            ></div>
            <div class="flex-1 mb-4" @mousemove="changeCursor('')">
              {{ program.date }} – {{ program.enddate }}
            </div>
            <info-panel
              @expandPanel="openPanel(index)"
              ref="text"
              :count="program.count"
              :excerpt="program.excerpt"
              :full="program.description"
            />
            <a
              v-if="program.document"
              :href="program.document.url"
              target="_blank"
              @mousemove="changeCursor('OPEN')"
              @mouseleave="changeCursor('')"
              >{{ program.document.name }}</a
            >
          </div>
        </div>
        <!-- right side -->
        <div class="col-span-7 pb-4 md:pl-0">
          <swiper
            @expandText="openText(index)"
            ref="swiper"
            :images="program.images"
          />
        </div>
      </div>

      <div
        v-for="(program, index) in current"
        :key="program.uid"
        class="w-full md:min-h-1/3 block md:grid md:grid-cols-10 pt-4 md:pt-8"
      >
        <!-- left side -->
        <div class="col-span-3 md:min-h-1/3 pr-4 pb-4 md:pb-0">
          <div class="w-full flex flex-col uppercase">
            <div
              v-if="index === 0"
              class="flex-1 w-full pb-4 uppercase"
              @mousemove="changeCursor('')"
            >
              CURRENT
            </div>
            <div class="flex-1 mb-4" @mousemove="changeCursor('')">
              {{ program.title }}
            </div>
            <div class="flex-1 mb-4" @mousemove="changeCursor('')">
              {{ program.date }} – {{ program.enddate }}
            </div>
            <info-panel
              @expandPanel="openPanel(index)"
              ref="text"
              :count="program.count"
              :excerpt="program.excerpt"
              :full="program.description"
            />
            <a
              v-if="program.document"
              :href="program.document.url"
              target="_blank"
              @mousemove="changeCursor('OPEN')"
              @mouseleave="changeCursor('')"
              >{{ program.document.name }}</a
            >
          </div>
        </div>
        <!-- right side -->
        <div class="col-span-7 pb-4 md:pl-0">
          <swiper
            @expandText="openText(index)"
            ref="swiper"
            :images="program.images"
          />
        </div>
      </div>

      <div
        v-for="(program, index) in past"
        :key="program.uid"
        class="w-full md:min-h-1/3 block md:grid md:grid-cols-10 pt-4 md:pt-8"
      >
        <!-- left side -->
        <div class="col-span-3 md:min-h-1/3 pr-4 pb-4 md:pb-0">
          <div class="w-full flex flex-col uppercase">
            <div
              @mousemove="changeCursor('')"
              v-if="index === 0"
              class="flex-1 w-full pb-4 uppercase"
            >
              PAST
            </div>
            <div @mousemove="changeCursor('')" class="flex-1 mb-4">
              {{ program.title }}
            </div>
            <div @mousemove="changeCursor('')" class="flex-1 mb-4">
              {{ program.date }} – {{ program.enddate }}
            </div>
            <info-panel
              ref="text"
              @expandPanel="openPanel(current.length + index)"
              :count="program.count"
              :excerpt="program.excerpt"
              :full="program.description"
            />
            <a
              v-if="program.document"
              :href="program.document.url"
              target="_blank"
              @mousemove="changeCursor('OPEN')"
              @mouseleave="changeCursor('')"
              >{{ program.document.name }}</a
            >
          </div>
        </div>
        <!-- right side -->
        <div class="col-span-7 pb-4 md:pl-0">
          <swiper
            @expandText="openText(current.length + index)"
            ref="swiper"
            :images="program.images"
          />
        </div>
      </div>
      <div class="h-screen"></div>
      <div v-if="busy" class="p-4 ta-c">Loading more</div>
    </div>
  </main>
</template>

<script>
import GridLetters from "@/components/GridLetters.vue";
import Swiper from "@/components/Swiper.vue";
import InfoPanel from "@/components/InfoPanel.vue";
import dayjs from "dayjs";
import { mapState } from "vuex";
export default {
  name: "programs",
  metaInfo: {
    title: "– Program",
  },
  components: {
    GridLetters,
    Swiper,
    InfoPanel,
  },
  data() {
    return {
      busy: false,
    };
  },
  computed: {
    ...mapState(["programs"]),
    current() {
      let filtered = this.programs.data.filter((item) => {
        var tod = dayjs().valueOf();
        var start = dayjs(item.date).valueOf();
        var end = dayjs(item.enddate).valueOf();
        return tod > start && tod < end;
      });
      return filtered;
    },
    past() {
      let filtered = this.programs.data.filter((item) => {
        var tod = dayjs().valueOf();
        var end = dayjs(item.enddate).valueOf();
        return tod > end;
      });
      return filtered;
    },
    upcoming() {
      let filtered = this.programs.data.filter((item) => {
        var tod = dayjs().valueOf();
        var start = dayjs(item.date).valueOf();
        return tod < start;
      });
      return filtered;
    },
  },
  methods: {
    openPanel(index) {
      this.$refs.swiper[index].toggle();
    },
    openText(index) {
      this.$refs.text[index].toggle();
    },
    loadMore() {
      this.busy = true;
      let curPage = this.programs.pagination.page;
      if (curPage < this.programs.pagination.pages) {
        this.$store.dispatch("loadPrograms", curPage + 1).then(() => {
          this.busy = false;
        });
      } else {
        this.busy = false;
      }
    },
    changeCursor(name) {
      this.$root.$emit("changeCursor", name);
    },
  },
};
</script>
